import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '../../../../../node_modules/@angular/platform-browser';

@Pipe({
  name: 'semDomPipe'
})
export class SemDomPipe implements PipeTransform {

  constructor(private sanitized: DomSanitizer) { }
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

}
